import AboutMe from "../components/AboutMe/AboutMe";

const About = () => {
    return (
        <div>
            <AboutMe />
        </div>
    );
}

export default About;